// Iter 182 — single source of truth for the Chapter officer line-up.
//
// Each entry drives: 1) the admin editor dropdowns, 2) the public
// Chapter card spotlight stack. The visual order below IS the on-card
// render order — grouped by rank, national officers first, then chapter
// officers, then the honorary Liaison.
//
// Star counts come straight from the org's protocol: four stars for the
// President, three for the Vice President, two for the Governor, one
// for everyone else. Directors are national offices that outrank the
// Governor despite showing one star, so they sit ABOVE Governor in the
// stack.
export const CHAPTER_OFFICER_SLOTS = [
    { key: "president_user_id",              out: "president",              title: "President",              stars: 4 },
    { key: "vice_president_user_id",         out: "vice_president",         title: "Vice President",         stars: 3 },
    { key: "director_of_membership_user_id", out: "director_of_membership", title: "Director of Membership", stars: 1 },
    { key: "director_of_operations_user_id", out: "director_of_operations", title: "Director of Operations", stars: 1 },
    { key: "director_of_marketing_user_id",  out: "director_of_marketing",  title: "Director of Marketing",  stars: 1 },
    { key: "governor_user_id",               out: "governor",               title: "Governor",               stars: 2 },
    { key: "lieutenant_governor_user_id",    out: "lieutenant_governor",    title: "Lieutenant Governor",    stars: 1 },
    { key: "secretary_user_id",              out: "secretary",              title: "Secretary",              stars: 2 },
    { key: "treasurer_user_id",              out: "treasurer",              title: "Treasurer",              stars: 2 },
    { key: "instructor_user_id",             out: "instructor",             title: "Instructor",             stars: 1 },
    // Liaison carries a four-leaf clover icon instead of stars — distinct
    // visual language because the role is honorary / goodwill-based rather
    // than ranked. `badgeIcon` tells the renderer to swap the Star loop.
    { key: "liaison_user_id",                out: "liaison",                title: "Liaison",                stars: 1, badgeIcon: "clover" },
];
